import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import user from "./modules/user";
import opera from "./modules/opera";
import eventAnalysis from "./modules/event-analysis";
import customizedQueries from "./modules/customized_queries";
import propertyAnalysis from "./modules/property-analysis";
import retentionAnalysis from "./modules/retention-analysis";
import dashboards from "./modules/dashboards";
import metadata from "./modules/metadata";
import segmentation from "./modules/segmentation";
import operationplan from "./modules/operation-plan";
import distribution from "./modules/distribution"
import funnel from "./modules/funnel"
import userHaviorPath from "./modules/user-behavior-path"
import ltv from "./modules/ltv"
import interval from "./modules/interval-analysis";

import attribution from "./modules/attribution";
import { otherRouter, appRouter } from "@/router/router";

Vue.use(Vuex);
localStorage.removeItem('store')
const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    resetState({ state, commit }) {
      for (let module in state) {
        commit(`RESET_${module}`);
      }
    },
    resetRouter() {
      otherRouter.children = [
        {
          path: "/view/home",
          title: "home",
          name: "home",
          component: () => import("@/views/home/home.vue")
        },
        {
          path: "/view/action-sequence",
          meta: {
            title: "用户行为序列"
          },
          name: "action-sequence",
          component: () => import("@/views/sequence/action-sequence.vue")
        },
        {
          path: "/view/user-detail-table/:type",
          meta: {
            title: "用户列表"
          },
          name: "user-detail-table",
          component: () =>
            import("@/views/user-detail-table/user-detail-table.vue")
        },
        {
          path: "/view/segmentation-result/:segmentationId",
          meta: {
            title: "用户分群结果"
          },
          name: "segmentation-result",
          component: () =>
            import("@/views/segmentation/segmentation-result.vue")
        }
      ];
      appRouter.children = [];
    }
  },
  modules: {
    app,
    user,
    eventAnalysis,
    customizedQueries,
    propertyAnalysis,
    retentionAnalysis,
    dashboards,
    segmentation,
    metadata,
    operationplan,
    opera,
    distribution,
    funnel,
    userHaviorPath,
    interval,
    ltv,
    userHaviorPath,
    attribution
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js